module.exports = __webpack_public_path__ + "img/hvac-mechanical-maintenance-05-xxlarge.ff721cb9.jpg";